import React from 'react';
import { useSelector } from 'react-redux';

import { LANGUAGES } from '../../config/constants';
import RequestPassword from './Request';
import ResetPassword from './Reset';

const PageResetPassword = () => {
  const currentPath = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const { uid, timestamp, hash } = getOneTimeLoginParams(currentPath);

  if (uid && timestamp && hash) {
    return <ResetPassword uid={uid} timestamp={timestamp} hash={hash} />;
  } else {
    return <RequestPassword />;
  }
};

function getOneTimeLoginParams(path) {
  const languagePrefixes = Object.keys(LANGUAGES);
  const pathIncludesLanguagePrefix = languagePrefixes.some((prefix) => path.startsWith(`/${prefix}`));
  const splitPath = path.split('/').slice(pathIncludesLanguagePrefix ? 4 : 3);

  return {
    uid: parseInt(splitPath[0]),
    timestamp: parseInt(splitPath[1]),
    hash: splitPath[2],
  };
}

export default PageResetPassword;
